"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetConfig_1 = require("../Model/WidgetConfig");
/**
 * Factory for widget configuration objects.
 */
class WidgetConfigFactory {
    /**
     * Creates widget factory.
     *
     * @param {ExtendableProvider} extendableManager
     */
    constructor(extendableManager) {
        this.extendableManager = extendableManager;
    }
    /**
     * Creates widget config.
     *
     * @param {*} configuration
     */
    create(configuration = {}) {
        const widgetConfigClass = this.extendableManager.getExtended(WidgetConfig_1.default);
        // @TODO: deep assign.
        configuration = Object.assign(widgetConfigClass.getDefaults(), configuration);
        return widgetConfigClass.fromObject(configuration);
    }
}
exports.default = WidgetConfigFactory;
